let lenisInstance = null;

export const setLenis = (instance) => {
    lenisInstance = instance;
};

export const scrollToId = (id) => {
    const el = document.getElementById(id);
    if (!el) return;
    if (lenisInstance && typeof lenisInstance.scrollTo === "function") {
        lenisInstance.scrollTo(el, { offset: -72, duration: 1.4 });
    } else {
        el.scrollIntoView({ behavior: "smooth" });
    }
};
